const contentIds = {
	'reviews-on-offerhubs': 1
};

const defaultLocale = {
	'reviews-on-offerhubs': 'Reviews on offerhubs (not configured!!!)'
};

const locale = {
	ru: defaultLocale,
	uk: defaultLocale,
	en: defaultLocale,
	de: defaultLocale,
	vi: defaultLocale,
	th: defaultLocale
};

module.exports = {
	enum: contentIds,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/banner-custom-content-ids.js